export default __webpack_public_path__ + "visa_inc_logo.726dae.svg";